// extracted by mini-css-extract-plugin
export var modalFooter = "_nh-0";